import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getOrders, getOrder } from "../actions/orderActions";
import { setPager } from "../actions/pagerActions";
import { withRouter } from "react-router";
import { utils } from "../common/utils";
import { OrderStatusEnum, OrderRefundStatusEnum } from "../common/enums";
import { withTranslation } from "react-i18next";
import CurrencyFormat from "../components/CurrencyFormat";
import DataTable from "react-data-table-component";
import { Breakpoint } from "react-socks";
import InvoiceViewer from '../components/InvoiceViewer';

function OrdersList({ t, orders, settings, user, getOrders, getOrder, onSelectOrder }) {
 const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
const [invoiceAction, setInvoiceAction] = useState({ id: null, type: null });

const triggerInvoice = (id, type) => {
  console.log("triggerInvoice" , id);
  setInvoiceAction({ id, type });
};

const clearInvoiceAction = () => {
  setInvoiceAction({ id: null, type: null });
};

  useEffect(() => {
    if (user?.id) {  getOrders(currentPage, perPage, user.id);}
  }, [getOrders, currentPage, perPage, user?.id]);

  const onRowClick = (saleId, orderId) => {
    getOrder(saleId).then(() => {onSelectOrder(orderId); utils.scrollTop();},
      (error) => {console.log(error);});
  };

  const getStatus = (o) => o.refundStatus === OrderRefundStatusEnum.None
      ? utils.orders.getOrderStatusString(o.status) : utils.orders.getOrderRefundStatusString(o.refundStatus);

  const getStatusColor = (order) => {
    if (order.status === OrderStatusEnum.Cancelled ||order.refundStatus !== OrderRefundStatusEnum.None)
      return "text-danger";
    else if (order.status === OrderStatusEnum.Ordered) return "text-warning";
    else if (order.status === OrderStatusEnum.Dispatched) return "text-success";
    return "text-info";
  };
  const handlePageChange = (page) => {
     setCurrentPage(page);
   };

   const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
   };

  if (!orders || orders.items.length === 0) {
    return (
      <div className="alert alert-info fade show text-center margin-bottom-1x">
        <i className="icon-layers"></i>&nbsp;&nbsp;
        <strong>{t("My Orders")}:</strong> {t("You don't have any orders")}.
      </div>
    );
  }

  const isProductPricesIncludeTax = orders.items[0].isProductPricesIncludeTax;

    const header = (label) => <span title={t(label)}>{t(label)}</span>;

    const columns = [
    { name: header("Order #"), selector: (row) => row.orderId, sortable: true, wrap: true,
        cell: (row) => (<button className="btn btn-link p-0" onClick={() => onRowClick(row.id, row.orderId)}>{row.orderId}</button>) },
    { name: header("Date Purchased"), selector: (row) => row.orderedAt, sortable: true, wrap: true,
        cell: (row) => utils.dates.getDateTime24String(row.orderedAt) },
    { name: header("Status"), selector: (row) => getStatus(row), sortable: true, wrap: true,
        cell: (row) => (<span className={getStatusColor(row)}>{t(getStatus(row))}</span>) },
    { name: header("Total Customer Price"), selector: (row) => row.totalCustomerPriceBeforeDiscountCode, wrap: true,
        cell: (row) => (<CurrencyFormat value={row.totalCustomerPriceBeforeDiscountCode} settings={settings} />) },
    { name: header("Discount"), selector: (row) => row.totalDiscountCodeAmount, wrap: true,
        cell: (row) => (<CurrencyFormat value={row.totalDiscountCodeAmount} settings={settings} />) },
    { name: header("Total Delivery Fees"), selector: (row) => row.totalDeliveryFees, wrap: true,
        cell: (row) => (<CurrencyFormat value={row.totalDeliveryFees} settings={settings} />) },
    !isProductPricesIncludeTax && { name: header("Total PST Tax"), selector: (row) => row.totalPSTTaxValue, wrap: true,
        cell: (row) => (<CurrencyFormat value={row.totalPSTTaxValue} settings={settings} />) },
    !isProductPricesIncludeTax && { name: header("Total HSTGST Tax"), selector: (row) => row.totalHSTGSTTaxValue, wrap: true,
        cell: (row) => (<CurrencyFormat value={row.totalHSTGSTTaxValue} settings={settings} />) },
    { name: header("Total"), selector: (row) => row.orderTotalAfterDiscount, wrap: true,
        cell: (row) => (<CurrencyFormat value={row.orderTotalAfterDiscount} settings={settings} />) },
    { name: header("Total Points"), selector: (row) => row.totalPoints, wrap: true },
    { name: header("Date Dispatched"), selector: (row) => row.dispatchedAt, wrap: true,
        cell: (row) => utils.dates.getDateTime24String(row.dispatchedAt) },
    ].filter(Boolean);


  const customStyles = {
    table: {
      style: {
        backgroundColor: "var(--theme-bg-surface)",
        color: "var(--theme-text-primary)",
      },
    },
    header: {
      style: {
        minHeight: "56px",
        backgroundColor: "var(--theme-bg-elevated)",
        color: "var(--theme-text-primary)",
        borderBottom: "1px solid var(--theme-border-soft)",
        paddingLeft: "16px",
        paddingRight: "16px",
      },
    },
    title: {
      style: {
        color: "var(--theme-text-primary)",
      },
    },
    headRow: { style: { minHeight: "44px", backgroundColor: "var(--theme-bg-elevated)", borderBottom: "2px solid var(--theme-border-soft)" } },
    headCells: { style: { padding: "8px 12px", fontSize: "14px", fontWeight: "600", color: "var(--theme-text-primary)", whiteSpace: "nowrap", overflow: "visible", textOverflow: "unset" } },
    rows: {
      style: {
        minHeight: "40px",
        backgroundColor: "var(--theme-bg-surface)",
        color: "var(--theme-text-secondary)",
        borderBottomColor: "var(--theme-border-soft)",
      },
      stripedStyle: {
        backgroundColor: "var(--theme-bg-elevated)",
      },
      highlightOnHoverStyle: {
        backgroundColor: "var(--theme-bg-elevated)",
        color: "var(--theme-text-primary)",
        outline: "none",
      },
    },
    cells: { style: { fontSize: "14px", color: "var(--theme-text-secondary)", padding: "8px 12px" } },
    pagination: {
      style: {
        backgroundColor: "var(--theme-bg-secondary)",
        color: "var(--theme-text-secondary)",
        borderTop: "1px solid var(--theme-border-soft)",
      },
      pageButtonsStyle: {
        color: "var(--theme-text-secondary)",
        fill: "var(--theme-text-secondary)",
        borderRadius: "50%",
        "&:disabled": {
          color: "var(--theme-text-muted)",
          fill: "var(--theme-text-muted)",
        },
        "&:hover:not(:disabled)": {
          backgroundColor: "var(--theme-bg-elevated)",
        },
        "&:focus": {
          outline: "none",
          backgroundColor: "var(--theme-bg-elevated)",
        },
      },
    },
    noData: {
      style: {
        backgroundColor: "var(--theme-bg-surface)",
        color: "var(--theme-text-secondary)",
      },
    },
  };

  return (
    <>
<Breakpoint small down>
  <div className="accordion padding-top-1x" role="tablist">
    {orders.items.map((o) => (
      <div className="card" key={o.id}>
        <div className="card-header" role="tab">
          <h6>
            <a
              href={`#collapse${o.id}`}
              data-toggle="collapse"
              data-parent="#accordion2"
            >
              <span className={`badge badge-pill ${getStatusColor(o)}`}>
                {t(getStatus(o))}
              </span>{" "}
              {`#${o.orderId}`}
              <span className="text-medium">
                &nbsp;&nbsp;&nbsp;{t("Total")}:&nbsp;
                <CurrencyFormat value={o.orderTotalAfterDiscount} settings={settings} />
              </span>
            </a>
          </h6>
        </div>
        <div className="collapse show" id={`collapse${o.id}`} role="tabpanel">
          <div className="card-body">
            <div className="padding-bottom-1x">
              <span>{t("Date Purchased")}:&nbsp;</span>
              <span className="text-medium">
                {utils.dates.getDateTime24String(o.orderedAt)}
              </span>
            </div>
            <div className="padding-bottom-1x">
              <span>{t("Total Customer Price")}:&nbsp;</span>
              <span className="text-medium">
                <CurrencyFormat value={o.totalCustomerPriceBeforeDiscountCode} settings={settings} />
              </span>
            </div>
            <div className={`padding-bottom-1x ${o.hasDiscountCodes ? "" : "hide"}`}>
              <span>{t("Discount")}:&nbsp;</span>
              <span className="text-medium">
                <CurrencyFormat value={o.totalDiscountCodeAmount} settings={settings} />
              </span>
            </div>
            <div className="padding-bottom-1x">
              <span>{t("Total Delivery Fees")}:&nbsp;</span>
              <span className="text-medium">
                <CurrencyFormat value={o.totalDeliveryFees} settings={settings} />
              </span>
            </div>
            <div className={`padding-bottom-1x ${isProductPricesIncludeTax ? "hide" : ""}`}>
              <span>{t("Total PST Tax")}:&nbsp;</span>
              <span className="text-medium">
                <CurrencyFormat value={o.totalPSTTaxValue} settings={settings} />
              </span>
            </div>
            <div className={`padding-bottom-1x ${isProductPricesIncludeTax ? "hide" : ""}`}>
              <span>{t("Total HSTGST Tax")}:&nbsp;</span>
              <span className="text-medium">
                <CurrencyFormat value={o.totalHSTGSTTaxValue} settings={settings} />
              </span>
            </div>
            <div className="padding-bottom-1x">
              <span>{t("Total")}:&nbsp;</span>
              <span className="text-medium">
                <CurrencyFormat value={o.orderTotalAfterDiscount} settings={settings} />
              </span>
            </div>
            <div className="padding-bottom-1x">
              <span>{t("Total Points")}:&nbsp;</span>
              <span className="text-medium">{o.totalPoints}</span>
            </div>
            <div className="padding-bottom-1x">
              <span>{t("Date Dispatched")}:&nbsp;</span>
              <span className="text-medium">
                {utils.dates.getDateTime24String(o.dispatchedAt)}
              </span>
            </div>
            <div className="padding-bottom-1x">
              <button className="btn btn-info" onClick={() => onRowClick(o.id, o.orderId)}>
                {t("More Details")}
              </button>
              </div>
              {/* New View PDF Button */}
              <div className="padding-bottom-1x">
            <button  className="btn btn-info" onClick={() => triggerInvoice(o.orderId, 'view')}>
               {t("View Invoice")}
            </button>
            <button  className="btn btn-info" onClick={() => triggerInvoice(o.orderId, 'download')}>
               {t("Download")}
            </button>
            </div>
            
          </div>
        </div>
      </div>
    ))}
    <InvoiceViewer 
        orderId={invoiceAction.id} 
        actionType={invoiceAction.type} 
        onCloseAction={clearInvoiceAction} 
      />
    {/* Pagination controls using server totalRecords */}
    <div className="d-flex justify-content-between mt-3">
      <button
        className="btn btn-secondary"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        {t("Previous")}
      </button>

      <span>
        {t("Page")} {currentPage} {t("of")} {Math.ceil(orders.totalRecords / perPage)}
      </span>

      <button
        className="btn btn-secondary"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === Math.ceil(orders.totalRecords / perPage)}
      >
        {t("Next")}
      </button>
    </div>
  </div>
</Breakpoint>


      <Breakpoint medium up>
        <DataTable
          title={t("My Orders")}
          columns={columns}
          data={orders.items}
          customStyles={customStyles} 
          pagination
          paginationServer
          paginationTotalRows={orders.totalRecords}
          paginationPerPage={perPage}
          paginationDefaultPage={currentPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          highlightOnHover
          striped
          responsive
          paginationComponentOptions={{
            rowsPerPageText: t("RowsPerPage"),
            rangeSeparatorText: t("of"),
            selectAllRowsItemText: t("All"),
          }}
          onRowClicked={(row) => onRowClick(row.id, row.orderId)}
          noDataComponent={<div style={{ padding: "16px", color: "var(--theme-text-secondary)" }}>{t("There are no records to display")}</div>}
        />
      </Breakpoint>
    </>
  );
}

function mapStateToProps({ orders, settings, user }, ownProps) {
  return { orders, settings, user, ...ownProps };
}

export default withTranslation()(
  withRouter(
    connect(mapStateToProps, { getOrders, getOrder, setPager })(OrdersList)
  )
);
